// extracted by mini-css-extract-plugin
export default {"totalYearCard":"TotalYear_totalYearCard__aUPPE","chartContainer":"TotalYear_chartContainer__M2rxr","titleMargin":"TotalYear_titleMargin__qUbxn"};